<template>
  <v-app>
    <v-app-bar app light color="brown lighten-5" class="header">
      <v-app-bar-nav-icon
        v-if="authenticated"
        @click="showDrawer = !showDrawer"
      ></v-app-bar-nav-icon>

      <v-img
        contain
        width="40"
        src="/favicon.png"
        class="shrink mr-2"
        v-if="!authenticated"
        transition="scale-transition"
      />

      <span>{{ $route.meta.description }}</span>

      <v-spacer></v-spacer>

      <div v-if="authenticated">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-on="on"
              class="mr-2"
              v-bind="attrs"
              @click="logoutUser"
            >
              <v-icon>mdi-lock-outline</v-icon>
            </v-btn>
          </template>
          <span>Logout</span>
        </v-tooltip>

        <Avatar :person="user" :class="'alt'" />
      </div>
    </v-app-bar>

    <Drawer v-if="authenticated" :show="showDrawer" />

    <v-main id="router-view">
      <v-container class="pt-7 pb-5" dense cols="12">
        <router-view :key="$route.fullPath"></router-view>
      </v-container>
    </v-main>

    <Snackbar />
    <Requesting />
  </v-app>
</template>

<script>
import Avatar from "./components/utils/Avatar";
import Drawer from "./components/utils/Drawer";

import Snackbar from "./utilities/SnackBar";
import Requesting from "./utilities/Requesting";

export default {
  name: "App",

  components: {
    Avatar,
    Drawer,
    Snackbar,
    Requesting,
  },

  data: () => ({
    showDrawer: false,
    authenticated: true,
    user: {
      first_name: "James",
      last_name: "Bond",
    },
  }),

  methods: {
    async logoutUser() {
      const authenticated = !!localStorage.getItem("uuEvoteAuth");
      if (authenticated) {
        await this.$axios.post("/logout");
      }
      localStorage.removeItem("uuEvoteAuth");
      localStorage.removeItem("uuEvoteUser");

      if (this.$router.currentRoute.name != "login") {
        this.$router.push({ name: "login" });
      }

      this.refereshAuth();
    },
    refereshAuth() {
      const authenticated = !!localStorage.getItem("uuEvoteAuth");
      this.authenticated = authenticated;

      if (authenticated) {
        this.user = JSON.parse(localStorage.getItem("uuEvoteUser"));

        this.desk = this.user.type == "desk";
        this.library = this.user.type == "library";
        this.identity = this.user.type == "identity";
        this.administrator =
          this.user.type == "admin" || this.user.type == "root";
      } else {
        localStorage.removeItem("uuEvoteAuth");
        localStorage.removeItem("uuEvoteUser");
        this.user = {
          role: 0,
          type: null,
          active: false,
          verified: false,
          name: "",
        };
      }
    },
  },

  mounted() {
    this.$bus.$on("request.initiated", () => (this.requesting = true));
    this.$bus.$on("request.ended", () => (this.requesting = false));

    this.refereshAuth();

    this.$bus.$on("login", this.refereshAuth);
    this.$bus.$on("logout", this.logoutUser);
  },
};
</script>


<style>
.v-dialog--fullscreen {
  overflow-x: hidden;
}

.candidate-image {
  border-radius: 4px;
}
</style>
